import { useNavigate } from 'react-router-dom';
import { useAccess } from '../../../hooks/useAccess';
import { BucketDetailView } from './BucketDetailView';
import { BucketsList } from './BucketsList';

/** Sales → Outreach Buckets. `/sales/pilots` lists the buckets; `/sales/pilots/:bucketId` is one bucket with all its people. */
export function PilotsPage({ bucketId }: { bucketId?: string }) {
  const navigate = useNavigate();
  const { isAdmin } = useAccess();
  if (!bucketId) return <BucketsList isAdmin={isAdmin} onOpen={(id) => navigate(`/sales/pilots/${id}`)} />;
  return <BucketDetailView id={bucketId} isAdmin={isAdmin} onBack={() => navigate('/sales/pilots')} />;
}
